import React, { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'antd'
import { AkaTypography } from 'components'
import logo from 'img/Logo_Herstellerportal.svg'
import { HEADER_HEIGHT } from 'modules/core/constants'

import { Link } from 'react-router-dom'
import { ROUTES } from '../../navigation'
import { useUser } from 'providers'
import { StyledATag, StyledFooter, StyledHeader } from './styles'

const PublicLayout: FC<{ children: ReactNode }> = ({ children }) => {
	const [t] = useTranslation()
	const { isAuthenticated, user } = useUser()

	return (
		<Layout>
			<StyledHeader>
				<Link to={ROUTES.login}>
					<img src={logo} width={300} alt="logo" />
				</Link>
			</StyledHeader>
			{children}
			<StyledFooter>
				<StyledATag href={ROUTES.imprint} rel="noopener noreferrer">
					<AkaTypography
						style={{ marginTop: HEADER_HEIGHT }}
						variant={'bodySegoe'}
						color={'primary'}
					>
						{t('auth.footer.impressum')}
					</AkaTypography>
				</StyledATag>
				<StyledATag href={ROUTES.privacyPolicy} rel="noopener noreferrer">
					<AkaTypography
						style={{ marginTop: HEADER_HEIGHT }}
						variant={'bodySegoe'}
						color={'primary'}
					>
						{t('auth.footer.privacyPolicy')}
					</AkaTypography>
				</StyledATag>
				<StyledATag href={ROUTES.termsOfUse} rel="noopener noreferrer">
					<AkaTypography
						style={{ marginTop: HEADER_HEIGHT }}
						variant={'bodySegoe'}
						color={'primary'}
					>
						{t('auth.footer.termsOfUse')}
					</AkaTypography>
				</StyledATag>
				<StyledATag href={ROUTES.sealTerms} rel="noopener noreferrer">
					<AkaTypography
						style={{ marginTop: HEADER_HEIGHT }}
						variant={'bodySegoe'}
						color={'primary'}
					>
						{t('auth.footer.sealTerms')}
					</AkaTypography>
				</StyledATag>
				<StyledATag
					href={
						isAuthenticated && user.id
							? ROUTES.securityIncident
							: ROUTES.publicSecurityIncident
					}
					rel="noopener noreferrer"
				>
					<AkaTypography
						style={{ marginTop: HEADER_HEIGHT }}
						variant={'bodySegoe'}
						color={'primary'}
					>
						{t('outreach.menu')}
					</AkaTypography>
				</StyledATag>
			</StyledFooter>
		</Layout>
	)
}

export default PublicLayout
